import {ID, Response} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'

export type ContactUs = {
  id?: ID
  name?: string
  email?: string
  subject?: string
  note?: string
  status?: boolean
  message?: string
  ticket_id?: string
  type?: 'support' | 'contact'
}

export type ContactUssQueryResponse = Response<Array<ContactUs>>

export const fields: FieldProps[] = [
  {
    name: 'ticket_id',
    label: 'Ticket ID',
    edit: false,
    create: false,
    table: true,
  },
  {name: 'name', label: 'Name', required: true, table: true, sortable: true},
  {
    name: 'email',
    label: 'Email',
    required: true,
    table: true,
    sortable: true,
    full: false,
  },
  {name: 'type', label: 'Type', table: true, sortable: true, create: false},
  {name: 'subject', label: 'Subject', required: true, table: false, sortable: true, full: true},
  {
    name: 'created_at',
    label: 'Created Date',
    table: true,
    sortable: true,
    type: 'date',
    create: false,
  },
  // {
  //   name: 'status',
  //   label: 'Status',
  //   type: 'switch',
  //   truthValue: 'Active',
  //   falseValue: 'Inactive',
  //   table: true,
  //   sortable: true,
  //   full: false,
  // },
  {name: 'message', label: 'Message', type: 'textarea', full: true, table: false},
]
